(function () {
  function isMatch() {
    // shopifyConfig (layout/theme.liquid) is declared with `const` at the
    // top level of a classic (non-module) inline <script> - that creates a
    // shared script-scope binding readable by name from any other classic
    // script in the same document, but it is NOT a property of `window`.
    // window.shopifyConfig is always undefined here.
    const config = typeof shopifyConfig !== 'undefined' ? shopifyConfig : {};
    const companyEnabled = !!config.agentShowOnCompanyStores;
    const nonCompanyEnabled = !!config.agentShowOnNonCompanyStores;
    if (!companyEnabled && !nonCompanyEnabled) return false;

    let node = null;
    try {
      const storeSelector = typeof window.storeSelector === 'function' ? window.storeSelector() : null;
      node = (storeSelector && storeSelector.nearestStore && storeSelector.nearestStore.node) || null;
      if (!node) {
        const cached = JSON.parse(localStorage.getItem('currentNearestStore') || 'null');
        node = (cached && cached.node) || null;
      }
    } catch (error) {
      node = null;
    }
    if (!node) return false;

    // A location whose companyStore metafield is unset entirely (e.g. Port
    // Melbourne, Hoppers Crossing, Ferntree Gully, Mt Ommaney, Cannington,
    // Morley) must match NEITHER branch below, rather than silently
    // defaulting to "non-company" - that silent default was the actual bug
    // (toggling off agentShowOnNonCompanyStores also hid the agent at these
    // genuine company stores). See GGpinia.js's nearestLocation() for the
    // matching three-way (true/false/null) value this depends on.
    const isCompanyStore = node.companyStore === true || node.companyStore === 'true';
    const isNotCompanyStore = node.companyStore === false || node.companyStore === 'false';
    return (companyEnabled && isCompanyStore) || (nonCompanyEnabled && isNotCompanyStore);
  }

  function applyVisibility() {
    const match = isMatch();
    const pending = document.querySelectorAll('.agent-pending-location-check');
    for (let i = 0; i < pending.length; i++) {
      pending[i].hidden = !match;
    }
  }

  function watchStoreSelector() {
    if (window.Vue && typeof window.Vue.watch === 'function' && typeof window.storeSelector === 'function') {
      window.Vue.watch(
        function () {
          return window.storeSelector().nearestStore;
        },
        applyVisibility,
        { deep: true },
      );
    }
  }

  applyVisibility();
  if (window.Vue && window.Pinia) {
    watchStoreSelector();
  } else {
    window.addEventListener('vue-ready', watchStoreSelector);
  }
  // Cross-tab fallback (Vue.watch above only covers changes made in this
  // tab) - matches the same event names sections/GGvideoBackground.liquid's
  // own inline script already reacts to for the same "resolved location
  // changed" concern.
  window.addEventListener('storage', function (event) {
    if (event.key === 'currentNearestStore' || event.key === 'vehicles' || event.key === 'activeVehicleId') applyVisibility();
  });
  window.addEventListener('vehicle-updated', applyVisibility);
})();
